import { transport } from 'config/transport';

export function callApiGetInvoice(congDoanId, classId, month) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${classId}/phieuthu`, { params: { month } });
}
